import { useStore } from '../store';

/** One-shot offline catch-up summary: shown after a boot restore that applied
 *  away time, dismissed by tap. The text is worker-reported (real seconds,
 *  sim ticks, cap); the UI never re-derives it, so a quick reload with no new
 *  away time shows nothing. */
export function AwayBanner() {
  const { sim, bridge } = useStore();
  if (sim.awayNotice === null) return null;
  return (
    <button class="away-banner" disabled={sim.savingDisabled === true} onClick={() => { bridge.dismissAwayNotice(); }}>
      <span>{sim.awayNotice}</span>
      <span class="away-banner-dismiss">{sim.savingDisabled ? 'Saving off' : 'Dismiss'}</span>
    </button>
  );
}
